module.exports = __webpack_public_path__ + "img/empty.7eb93e98.svg";